import { PcsInformationConstants } from './pcsInformation.constants'
import { IPcsInformationState, IPcsInformationAction } from './pcsInformation.types'
import { getCurrentDate, getCurrentTime } from '../../../utilities'

export const initialPcsInformationState: IPcsInformationState = {
  nppFormGiven: null,
  consentFormSigned: null,
  medicalNecessitySigned: null,
  pcsReason: [],
  pcsProviderType: null,
  lastName: '',
  firstName: '',
  milesToHosp: '',
  pcsSignedTime: '',
  pcsSignedDate: '',
}

export function pcsInformationReducer(
  state: IPcsInformationState = initialPcsInformationState,
  action: IPcsInformationAction
): IPcsInformationState {
  switch (action.type) {
    case PcsInformationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PcsInformationConstants.SET_NPPFORMGIVEN:
      return { ...state, nppFormGiven: action.nppFormGiven }
    case PcsInformationConstants.SET_CONSENTFORMSIGNED:
      return { ...state, consentFormSigned: action.consentFormSigned }
    case PcsInformationConstants.SET_MEDICALNECESSITYSIGNED:
      return { ...state, medicalNecessitySigned: action.medicalNecessitySigned }
    case PcsInformationConstants.SET_PCSREASON:
      return { ...state, pcsReason: action.pcsReason }
    case PcsInformationConstants.SET_PCSPROVIDERTYPE:
      return { ...state, pcsProviderType: action.pcsProviderType }
    case PcsInformationConstants.SET_LASTNAME:
      return { ...state, lastName: action.lastName }
    case PcsInformationConstants.SET_FIRSTNAME:
      return { ...state, firstName: action.firstName }
    case PcsInformationConstants.SET_MILESTOHOSP:
      return { ...state, milesToHosp: action.milesToHosp }
    case PcsInformationConstants.SET_PCSSIGNEDTIME:
      return { ...state, pcsSignedTime: action.pcsSignedTime }
    case PcsInformationConstants.SET_PCSSIGNEDDATE:
      return { ...state, pcsSignedDate: action.pcsSignedDate }
    case PcsInformationConstants.ADD_CURRENT_TIME:
      return { ...state, pcsSignedTime: getCurrentTime(), pcsSignedDate: getCurrentDate() }
    case PcsInformationConstants.SET_PCSINFORMATION:
      return { ...state, ...action.pcsInformation }
    case PcsInformationConstants.RESET_PCSINFORMATION_STATE:
      return {
        nppFormGiven: null,
        consentFormSigned: null,
        medicalNecessitySigned: null,
        pcsReason: [],
        pcsProviderType: null,
        lastName: '',
        firstName: '',
        milesToHosp: '',
        pcsSignedTime: '',
        pcsSignedDate: '',
      }
    default:
      return state
  }
}
